import React from 'react';
import PropTypes from 'prop-types';
import { OnLive } from 'components/on-live';

const HighlightsPanel = ({ model }) => {
    if (!model) return null;

    const bemCss = model.mode ? `highlights-panel--${model.mode}` : '';

    return (
        <div className={`highlights-panel ${bemCss}`}>
            <div className="highlights-panel__heading">
                {model.isLive && <div className="highlights-panel__live"><OnLive /></div>}
                <h2 className="highlights-panel__title">{model.title}</h2>
            </div>
            <ul className="highlights-panel__list">
                {
                    Array.isArray(model.items) &&
                    model.items.map((highlight) => (
                        <li
                            className="highlights-panel__li"
                            key={highlight.id}
                            dangerouslySetInnerHTML={{ __html: highlight.body }} />
                    ))
                }
            </ul>
            <div className="highlights-panel__patron">
                {model.patronImageUrl &&
                <img key={model.patronImageUrl} className="lazyload" data-srcset={model.patronImageUrl} alt="" />}
            </div>
        </div>
    );
};

HighlightsPanel.propTypes = {
    model: PropTypes.object,
};

export default HighlightsPanel;
